import React from "react";

const CheckIcon = ({ width = 79, height = 79 }: any) => {
  return (
    <>
      <svg
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M70.9807 0L22.0829 53.7732L7.88675 43.0209H0L22.0829 78.8675L78.8675 0H70.9807Z"
          fill="#47B2FF"
        />
      </svg>
    </>
  );
};

export default CheckIcon;
